export const LANGUAGES_MAP = {
    'IT': 'italian',
    'DE': 'german',
    'FR': 'french',
    'EN': 'english',
    'EN_US': 'english',
    'JA': 'japanese',
    'KO': 'korean',
    'RU': 'russian',
    'ES': 'spanish',
    'CN': 'korean'
}
export const LOCALE_MAP = {
    'IT': 'it_IT',
    'DE': 'de_DE',
    'FR': 'fr_FR',
    'EN': 'en_GB',
    'JA': 'ja_JP',
    'ES': 'es_ES',
    'CN': 'zh_CN',
    'RU': 'ru_RU',
    'KO': 'ko_KR',
    'EN_US': 'en_US'
}

export const CODE_TO_LANG = {
    'it_IT':'IT',
    'de_DE':'DE',
    'fr_FR':'FR',
    'en_GB':'EN',
    'ja_JP':'JA',
    'es_ES':'ES',
    'zh_CN':'CN',
    'ru_RU':'RU',
    'ko_KR':'KO'
}




